export default "__VITE_ASSET__726a03c9__"